import React from 'react';
import { useTranslation } from 'react-i18next';

const IpadWarningView = () => {
  const { t } = useTranslation();
  return <div id='warning-message'>{t('Please view in Landscape mode.')}</div>;
};
export default IpadWarningView;
